module.exports = __webpack_public_path__ + "media/assets/images/arrows/arrowDownGreen-9ce184737b36ea1d854cae769e097246.svg";